module.exports = __webpack_public_path__ + "static/img/Popcorner-Standee.5be9257.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Popcorner-Standee.jpg
// module id = RfGf
// module chunks = 11